import { Injectable } from '@angular/core';
import { environment } from '@rocksoft/environment';
import { HubService } from './hub.service';

@Injectable({ providedIn: 'root' })
export class DeviceTaskManagementHubService extends HubService {
  constructor() {
    super(`${environment.devicetaskmanagement.api}/hubs/device-task-management`);
  }
}
